// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"816b65d5","640":"688f4fc1"}[chunkId] + ".chunk.js";
};